import { Transform } from 'class-transformer';

/**
 * Trims surrounding whitespace and turns blank strings into undefined, so the
 * validators and the persisted value see the same, clean string.
 */
export function OptionalTrimmedStringTransform(): PropertyDecorator {
  return Transform(({ value }) => {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed === '' ? undefined : trimmed;
  });
}
